import React from 'react';
import {useTranslation} from 'react-i18next';

import throttle from 'lodash/throttle';

import {NewTextInputField, Spinner} from '@edna/components';
import {useOnMount} from '@edna/hooks';

import {RefreshIcon} from 'src/icons';

import {useGetCaptchaQuery} from '../api';
import * as S from './style';

const CaptchaContainer = React.memo<{
  disabled?: boolean;
  className?: string;
  throttleTimeout: number;
}>(({className, disabled, throttleTimeout}) => {
  const {t} = useTranslation();
  const {data: captcha, refetch, isFetching} = useGetCaptchaQuery();

  const handleRefreshCaptcha = React.useCallback(
    throttle(() => refetch(), throttleTimeout, {trailing: false}),
    [refetch],
  );

  useOnMount(handleRefreshCaptcha);

  return (
    <>
      <div className={className}>
        <S.CaptchaImageWithIcon>
          <S.CaptchaImg>
            {isFetching ? (
              <Spinner size="32px" />
            ) : (
              <img
                src={`data:image/jpeg;base64,${captcha?.captcha}`}
                alt="captchaURL"
                {...edna.renderTestId(edna.TEST_IDS.AUTH.CAPTCHA_IMAGE)}
              />
            )}
          </S.CaptchaImg>
          <S.RefreshButton
            onClick={handleRefreshCaptcha}
            loading={isFetching}
            disabled={disabled}
            {...edna.renderTestId(edna.TEST_IDS.AUTH.CAPTCHA_UPDATE)}
          >
            <RefreshIcon />
          </S.RefreshButton>
        </S.CaptchaImageWithIcon>
        <NewTextInputField
          name="captcha"
          disabled={disabled}
          label={t('Auth:signIn.captchaLabel')}
          autoComplete="off"
        />
      </div>
    </>
  );
});

CaptchaContainer.displayName = 'CaptchaContainer';

export default CaptchaContainer;
